import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';


export interface DeleteConfirmationModalProps {
    controller: DeleteConfirmationModalController;
    text?: string | React.ReactNode;
    title?: string | React.ReactNode;
    onConfirm?: (() => void);
    onCancel?: (() => void);
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = (props: DeleteConfirmationModalProps) => {

    function onCancel() {
        props.controller.close();
        const handler = props.controller.state.onCancel ?? props.onCancel;
        
        if (handler) handler();
    }

    function onConfirm() {
        const handler = props.controller.state.onConfirm ?? props.onConfirm;
        
        if (handler) handler();
        props.controller.close();
    }

    return <Modal show={props.controller.state.isShowing} backdrop="static">
        <Modal.Header>
            <Modal.Title>
                <i className="fa fa-exclamation-triangle" style={{ color: 'var(--danger-color)' }} /> {props.controller.state.title ?? props.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {props.controller.state.text ?? props.text}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onCancel}>
                No, Go Back
            </Button>
            <Button variant="danger" onClick={onConfirm}>
                Yes, Delete
            </Button>
        </Modal.Footer>
    </Modal>
}

export default DeleteConfirmationModal;

export interface DeleteConfirmationModalState {
    isShowing: boolean;
    title?: string;
    text?: string;
    onConfirm?: (() => void);
    onCancel?: (() => void);
}

export interface DeleteConfirmationModalController {
    show(title?: string, text?: string, successHandler?: (() => void), cancelHandler?: (() => void)): void;
    close(): void;
    state: DeleteConfirmationModalState;
}

export function useDeleteConfirmationModal(): DeleteConfirmationModalController {

    const [modalState, setModalState] = useState<DeleteConfirmationModalState>({isShowing: false});

    function show(title?: string, text?: string, successHandler?: (() => void), cancelHandler?: (() => void)) {
        setModalState({ isShowing: true, title, text, onConfirm: successHandler, onCancel: cancelHandler});
    }

    function close() {
        setModalState(m => ({...m, isShowing: false}))
    }

    return {
        state: modalState,
        show,
        close
    }

}